export const LOADING = 'loading';
export const SUCCESS = 'success';
export default [LOADING, SUCCESS];
